var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_425_445)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 13.5H14.4375C14.127 13.5 13.875 13.248 13.875 12.9375C13.875 12.627 14.127 12.375 14.4375 12.375H15.9375C16.4542 12.375 16.875 11.9542 16.875 11.4375V6.56255C16.875 6.04578 16.4542 5.625 15.9375 5.625H2.06255C1.54578 5.625 1.125 6.04578 1.125 6.56255V11.4375C1.125 11.9542 1.54578 12.375 2.06255 12.375H3.56245C3.87296 12.375 4.12495 12.627 4.12495 12.9375C4.12495 13.248 3.87296 13.5 3.56245 13.5H2.06255C0.924774 13.5 0 12.5752 0 11.4375V6.56255C0 5.42477 0.924774 4.5 2.06255 4.5H15.9375C17.0752 4.5 18 5.42477 18 6.56255V11.4375C18 12.5752 17.0752 13.5 15.9375 13.5Z",
    fill: "#CC5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9375 18H5.06255C3.92477 18 3 17.0753 3 15.9375V10.3125C3 10.002 3.252 9.75 3.5625 9.75H14.4376C14.7481 9.75 15.0001 10.002 15.0001 10.3125V15.9375C15.0001 17.0753 14.0753 18 12.9375 18ZM4.125 10.875V15.9375C4.125 16.4543 4.54578 16.875 5.06255 16.875H12.9375C13.4543 16.875 13.8751 16.4543 13.8751 15.9375V10.875H4.125Z",
    fill: "#CC5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1876 13.5H5.8125C5.502 13.5 5.25 13.248 5.25 12.9375C5.25 12.627 5.502 12.375 5.8125 12.375H12.1876C12.4981 12.375 12.7501 12.627 12.7501 12.9375C12.7501 13.248 12.4981 13.5 12.1876 13.5Z",
    fill: "#CC5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1876 15.75H5.8125C5.502 15.75 5.25 15.498 5.25 15.1875C5.25 14.877 5.502 14.625 5.8125 14.625H12.1876C12.4981 14.625 12.7501 14.877 12.7501 15.1875C12.7501 15.498 12.4981 15.75 12.1876 15.75Z",
    fill: "#CC5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4376 5.625C14.1271 5.625 13.8751 5.373 13.8751 5.0625V3.93228C13.8751 3.48157 13.6996 3.05777 13.3808 2.73903L12.2617 1.61993C11.9475 1.30504 11.5133 1.125 11.0685 1.125H5.06255C4.54578 1.125 4.125 1.54578 4.125 2.06255V5.0625C4.125 5.373 3.873 5.625 3.5625 5.625C3.252 5.625 3 5.373 3 5.0625V2.06255C3 0.924774 3.92477 0 5.06255 0H11.0685C11.8088 0 12.5341 0.300064 13.0567 0.824249L14.1758 1.94321C14.7076 2.47495 15.0001 3.1815 15.0001 3.93228V5.0625C15.0001 5.373 14.7481 5.625 14.4376 5.625Z",
    fill: "#CC5A5A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_425_445"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.aecde6a1a0e5e688ebef305e63c8a4ec.svg";
export { ForwardRef as ReactComponent };